//Ajouter Declarations

import React, { useState, useEffect, useRef } from "react";
import {
  Container,
  Typography,
  Select,
  MenuItem,
  Button
} from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import '../CSS/ajouterdeclarations.css';
import axios from 'axios';
import apiUrl from '../config'; // Assure-toi que ton apiUrl est bien importé
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';

import LayoutDashboard from '../layout/LayoutDashboard';
import { NovaSectionLoader } from './ui/NovaLoader';

const AjouterDeclarations = () => {
    const [selectedMonth, setSelectedMonth] = useState(null);
    const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
    const [workDays, setWorkDays] = useState({});
    const [leaveDays, setLeaveDays] = useState({});
    const [isDragging, setIsDragging] = useState(false);
    const [currentType, setCurrentType] = useState(null);
    const [isEditMode, setIsEditMode] = useState(false);
    const [selectedUserId, setSelectedUserId] = useState(null);  // ✅ Ajouté ici
    const [declarationId, setDeclarationId] = useState(null);    // ✅ Ajouté ici
    const navigate = useNavigate();
    const location = useLocation();
    const [notification, setNotification] = useState({ open: false, message: '', severity: 'success' });
    const [loading, setLoading] = useState(false);
    const [loadingEditView, setLoadingEditView] = useState(false); // 🔄 nouveau
    const [blockedDaysMap, setBlockedDaysMap] = useState({});
    const [monthDeclarationBlocked, setMonthDeclarationBlocked] = useState(false);
    const [monthDeclarationBlockedMessage, setMonthDeclarationBlockedMessage] = useState('');

    // V166_FORCE_REAL_RENDERED_DAY_COLORS_DECLARATIONS
    useEffect(() => {
        const toKey = (date) => {
            const y = date.getFullYear();
            const m = String(date.getMonth() + 1).padStart(2, '0');
            const d = String(date.getDate()).padStart(2, '0');
            return `${y}-${m}-${d}`;
        };

        const addDays = (date, days) => {
            const clone = new Date(date);
            clone.setDate(clone.getDate() + days);
            return clone;
        };

        const getEasterDate = (year) => {
            const a = year % 19;
            const b = Math.floor(year / 100);
            const c = year % 100;
            const d = Math.floor(b / 4);
            const e = b % 4;
            const f = Math.floor((b + 8) / 25);
            const g = Math.floor((b - f + 1) / 3);
            const h = (19 * a + b - d - g + 15) % 30;
            const i = Math.floor(c / 4);
            const k = c % 4;
            const l = (32 + 2 * e + 2 * i - h - k) % 7;
            const mm = Math.floor((a + 11 * h + 22 * l) / 451);
            const month = Math.floor((h + l - 7 * mm + 114) / 31);
            const day = ((h + l - 7 * mm + 114) % 31) + 1;
            return new Date(year, month - 1, day);
        };

        const getFrenchHolidayKeys = (year) => {
            const easter = getEasterDate(year);

            return new Set([
                new Date(year, 0, 1),
                addDays(easter, 1),
                new Date(year, 4, 1),
                new Date(year, 4, 8),
                addDays(easter, 39),
                addDays(easter, 50),
                new Date(year, 6, 14),
                new Date(year, 7, 15),
                new Date(year, 10, 1),
                new Date(year, 10, 11),
                new Date(year, 11, 25),
            ].map(toKey));
        };

        const clearForced = (cell, isHeader = false) => {
            if (!cell || cell.dataset.novaForcedRealColor !== 'true') return;

            [
                'background',
                'background-color',
                'background-image',
                'border',
                'color',
                'box-shadow',
                'opacity'
            ].forEach((prop) => cell.style.removeProperty(prop));

            cell.style.setProperty('cursor', isHeader ? 'default' : 'pointer');

            delete cell.dataset.novaForcedRealColor;
            delete cell.dataset.novaForcedRealType;
        };

        const forceCell = (cell, type) => {
            if (!cell) return;

            const palette = {
                weekend: {
                    background: 'linear-gradient(135deg, #cbd5e1, #e2e8f0)',
                    border: '2px dashed #94a3b8'
                },
                holiday: {
                    background: 'linear-gradient(135deg, #94a3b8, #64748b)',
                    border: '2px dashed #64748b'
                },
                existing: {
                    background: 'linear-gradient(135deg, #93c5fd, #60a5fa)',
                    border: '2px dashed #3b82f6'
                }
            };

            const color = palette[type];
            if (!color) return;

            cell.dataset.novaForcedRealColor = 'true';
            cell.dataset.novaForcedRealType = type;

            cell.style.setProperty('background', color.background, 'important');
            cell.style.setProperty('background-color', type === 'existing' ? '#93c5fd' : type === 'holiday' ? '#94a3b8' : '#cbd5e1', 'important');
            cell.style.setProperty('background-image', color.background, 'important');
            cell.style.setProperty('border', color.border, 'important');
            cell.style.setProperty('color', '#0f172a', 'important');
            cell.style.setProperty('cursor', 'not-allowed', 'important');
            cell.style.setProperty('opacity', '1', 'important');
            cell.style.setProperty('box-shadow', 'inset 0 1px 0 rgba(255,255,255,0.20)', 'important');
        };

        const applyColors = () => {
            const table = document.querySelector('.declarations-add-page table');
            if (!table || !selectedMonth || !selectedYear) return;

            const rows = Array.from(table.querySelectorAll('tr'));
            if (!rows.length) return;

            const headerRow = rows[0];
            const headerCells = Array.from(headerRow.querySelectorAll('th, td')).slice(1);
            const bodyRows = rows.slice(1);
            const holidays = getFrenchHolidayKeys(Number(selectedYear));

            headerCells.forEach((headerCell, index) => {
                const day = index + 1;
                const date = new Date(Number(selectedYear), Number(selectedMonth) - 1, day);

                if (date.getMonth() !== Number(selectedMonth) - 1) return;

                const dateKey = toKey(date);
                const isWeekendDay = date.getDay() === 0 || date.getDay() === 6;
                const isHolidayDay = holidays.has(dateKey);

                if (isHolidayDay) {
                    forceCell(headerCell, 'holiday');
                } else if (isWeekendDay) {
                    forceCell(headerCell, 'weekend');
                } else {
                    clearForced(headerCell, true);
                }

                bodyRows.forEach((row) => {
                    const cells = Array.from(row.querySelectorAll('th, td'));
                    const cell = cells[index + 1];

                    if (!cell) return;

                    const isExisting = blockedDaysMap?.[day] === 'bloqué';

                    if (isExisting) {
                        forceCell(cell, 'existing');
                    } else if (isHolidayDay) {
                        forceCell(cell, 'holiday');
                    } else if (isWeekendDay) {
                        forceCell(cell, 'weekend');
                    } else {
                        clearForced(cell, false);
                    }
                });
            });
        };

        applyColors();

        const timers = [
            setTimeout(applyColors, 50),
            setTimeout(applyColors, 200),
            setTimeout(applyColors, 600),
            setTimeout(applyColors, 1200)
        ];

        return () => {
            timers.forEach(clearTimeout);
        };
    }, [selectedMonth, selectedYear, blockedDaysMap, workDays, leaveDays]);

    const [isDaysLoading, setIsDaysLoading] = useState(false);
    const blockedFetchedRef = useRef(false); // ✅ évite les doubles appels

    


// V152_CLEAR_DECLARATION_BLOCK_ON_EDIT
useEffect(() => {
  const pageIsEditMode = Boolean(isEditMode || declarationId || location.state?.declarationId);

  if (pageIsEditMode) {
    setMonthDeclarationBlocked(false);
    setMonthDeclarationBlockedMessage('');
  }
}, [isEditMode, declarationId, location.state]);

     // ✅ ÉTAPE 1 : résoudre l'userId une seule fois
useEffect(() => {
  let resolvedUserId = null;

  if (location.state?.selectedUserId) {
    resolvedUserId = normalizeUserId(location.state.selectedUserId);
  } else {
    const stored = localStorage.getItem("selectedUserId");
    if (stored) {
      resolvedUserId = stored;
    } else {
      try {
        const token = localStorage.getItem('token');
        if (token) {
          const decoded = JSON.parse(atob(token.split('.')[1]));
          resolvedUserId = decoded.user_id;
        }
      } catch {}
    }
  }

  if (resolvedUserId) setSelectedUserId(resolvedUserId);
}, []); // ← les [] sont importants : s'exécute UNE seule fois

// ✅ ÉTAPE 2 : charger la déclaration si mode édition
useEffect(() => {
  if (!location.state?.declarationId) return;

  setIsEditMode(true);
  setDeclarationId(location.state.declarationId);
  setLoadingEditView(true);

  const fetchDeclaration = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(
        `${apiUrl}/declarations/details/${location.state.declarationId}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      if (response.status === 200) {
        const declaration = response.data;

        const workDaysArray = (declaration.Jours_Selectionnes || "")
          .split("/  ").map(d => d.trim()).filter(Boolean);
        const leaveDaysArray = (declaration.jours_congé || "")
          .split("/  ").map(d => d.trim()).filter(Boolean);

        const workObj = {};
        const leaveObj = {};

        workDaysArray.forEach(date => {
          const day = new Date(date).getDate();
          workObj[day] = 1;
        });
        leaveDaysArray.forEach(date => {
          const day = new Date(date).getDate();
          leaveObj[day] = 1;
        });

        Object.keys(workObj).forEach(day => {
          if (leaveObj[day]) {
            workObj[day] = 0.5;
            leaveObj[day] = 0.5;
          }
        });

        setWorkDays(workObj);
        setLeaveDays(leaveObj);

        const firstDate = new Date(workDaysArray[0] || leaveDaysArray[0]);
        setSelectedMonth(firstDate.getMonth() + 1);
        setSelectedYear(firstDate.getFullYear());

        if (!location.state.selectedUserId) {
          setSelectedUserId(declaration.Id_Utilisateur);
        }
      }
    } catch (error) {
      console.error('Erreur chargement déclaration :', error);
    } finally {
      setLoadingEditView(false);
    }
  };

  fetchDeclaration();
}, []); // ← les [] sont importants : s'exécute UNE seule fois

// ✅ ÉTAPE 3 : charger les jours bloqués quand tout est prêt
useEffect(() => {
  if (!selectedMonth || !selectedYear || !selectedUserId) return;
  if (blockedFetchedRef.current) return; // évite les doubles appels

  blockedFetchedRef.current = true;
  loadBlockedDays(selectedMonth, selectedYear, selectedUserId);

}, [selectedMonth, selectedYear, selectedUserId]); // ← ces 3 dépendances sont correctes ici

    

// 👇 Normalise l'ID utilisateur (accepte nombre, string, ou objet)
const normalizeUserId = (raw) => {
  if (raw == null) return null;
  if (typeof raw === 'object') return raw.id || raw.Id_Utilisateur || null;
  return raw; // nombre ou string OK
};


const splitNovaDates = (value) => {
  return String(value || '')
    .split('/')
    .map((item) => item.trim())
    .filter(Boolean);
};

const dateBelongsToMonth = (dateValue, month, year) => {
  const match = String(dateValue || '').match(/(\d{4})-(\d{1,2})-(\d{1,2})/);

  if (!match) return false;

  return Number(match[1]) === Number(year) && Number(match[2]) === Number(month);
};

const declarationHasWorkOrLeaveForMonth = (declaration, month, year) => {
  const workDates = splitNovaDates(
    declaration.Jours_Selectionnes ||
    declaration.jours_selectionnes ||
    declaration.joursSelectionnes
  );

  const leaveDates = splitNovaDates(
    declaration['jours_congé'] ||
    declaration.jours_conge ||
    declaration.joursCongé ||
    declaration.joursConge
  );

  return (
    workDates.some((date) => dateBelongsToMonth(date, month, year)) ||
    leaveDates.some((date) => dateBelongsToMonth(date, month, year))
  );
};

const checkDeclarationMonthAlreadyExists = async (month, year, userId) => {
  const validUserId = normalizeUserId(userId);

  const pageIsEditMode = Boolean(isEditMode || declarationId || location.state?.declarationId);

  if (!validUserId || !month || !year || pageIsEditMode) {
    setMonthDeclarationBlocked(false);
    setMonthDeclarationBlockedMessage('');
    return false;
  }

  try {
    const token = localStorage.getItem('token');

    const response = await axios.get(`${apiUrl}/declarations/${validUserId}`, {
      headers: { Authorization: `Bearer ${token}` }
    });

    const declarations = Array.isArray(response.data)
      ? response.data
      : Array.isArray(response.data?.declarations)
        ? response.data.declarations
        : Array.isArray(response.data?.data)
          ? response.data.data
          : [];

    const exists = declarations.some((declaration) =>
      declarationHasWorkOrLeaveForMonth(declaration, month, year)
    );

    if (exists) {
      const message = 'Ce mois est déjà déclaré. Pour ajouter ou corriger les jours travaillés/congés, passez par Modifier.';

      setMonthDeclarationBlocked(true);
      setMonthDeclarationBlockedMessage(message);
      setNotification({
        open: true,
        message,
        severity: 'warning'
      });

      return true;
    }

    setMonthDeclarationBlocked(false);
    setMonthDeclarationBlockedMessage('');
    return false;
  } catch (error) {
    console.error('Erreur vérification déclaration existante :', error);
    setMonthDeclarationBlocked(false);
    setMonthDeclarationBlockedMessage('');
    return false;
  }
};

// ✅ Nouvelle fonction centralisée pour charger les jours bloqués
const loadBlockedDays = async (month, year, userId) => {
  const validUserId = normalizeUserId(userId);
  if (!validUserId || !month || !year) return;

  setIsDaysLoading(true);

  try {
    const token = localStorage.getItem('token');
    const url = isEditMode
      ? `${apiUrl}/declarations/jours-bloques/${validUserId}/${month}/${year}?exclude_id=${declarationId}`
      : `${apiUrl}/declarations/jours-bloques/${validUserId}/${month}/${year}`;

    const response = await axios.get(url, {
      headers: { Authorization: `Bearer ${token}` }
    });

    if (response.status === 200) {
      await checkDeclarationMonthAlreadyExists(month, selectedYear || year, validUserId);
      const joursBloques = response.data;
      const map = {};
      const existingDays = { ...workDays, ...leaveDays };

      for (const jour of joursBloques) {
        if (!(jour in existingDays)) {
          map[jour] = "bloqué";
        }
      }
      setBlockedDaysMap(map);
    }
  } catch (error) {
    console.error("Erreur jours bloqués :", error);
  } finally {
    setIsDaysLoading(false);
  }
};
    
   // ✅ REMPLACER ces 2 handlers par ceci
const handleMonthChange = async (e) => {
  const month = parseInt(e.target.value);
  setSelectedMonth(month);
  setWorkDays({});
  setLeaveDays({});
  setBlockedDaysMap({});
  blockedFetchedRef.current = false;
  await loadBlockedDays(month, selectedYear, selectedUserId);
  await checkDeclarationMonthAlreadyExists(month, selectedYear, selectedUserId);
  blockedFetchedRef.current = true;
};

const handleYearChange = async (e) => {
  const year = parseInt(e.target.value, 10);
  setSelectedYear(year);
  setWorkDays({});
  setLeaveDays({});
  setBlockedDaysMap({});
  if (selectedMonth && selectedUserId) {
    blockedFetchedRef.current = false;
    await loadBlockedDays(selectedMonth, year, selectedUserId);
    await checkDeclarationMonthAlreadyExists(selectedMonth, year, selectedUserId);
    blockedFetchedRef.current = true;
  }
};

    const getDaysInMonth = (year, month) => {
        const daysInMonth = new Date(year, month, 0).getDate();
        return Array.from({ length: daysInMonth }, (_, i) => i + 1);
    };
    

    const toggleDay = (day, type) => {
        if (blockedDaysMap[day] === "bloqué") return;
        const isWork = workDays[day];
        const isLeave = leaveDays[day];
    
        if (type === "work") {
            if (isWork === 1) {
                const newWorkDays = { ...workDays };
                delete newWorkDays[day];
                setWorkDays(newWorkDays);
            } else if (isWork === 0.5 && isLeave === 0.5) {
                // Désélectionne travail → congé passe à 1
                const newWorkDays = { ...workDays };
                const newLeaveDays = { ...leaveDays, [day]: 1 };
                delete newWorkDays[day];
                setWorkDays(newWorkDays);
                setLeaveDays(newLeaveDays);
            } else if (isLeave === 1) {
                setWorkDays({ ...workDays, [day]: 0.5 });
                setLeaveDays({ ...leaveDays, [day]: 0.5 });
            } else {
                setWorkDays({ ...workDays, [day]: 1 });
            }
        }
    
        if (type === "leave") {
            if (isLeave === 1) {
                const newLeaveDays = { ...leaveDays };
                delete newLeaveDays[day];
                setLeaveDays(newLeaveDays);
            } else if (isLeave === 0.5 && isWork === 0.5) {
                // Désélectionne congé → travail passe à 1
                const newLeaveDays = { ...leaveDays };
                const newWorkDays = { ...workDays, [day]: 1 };
                delete newLeaveDays[day];
                setLeaveDays(newLeaveDays);
                setWorkDays(newWorkDays);
            } else if (isWork === 1) {
                setWorkDays({ ...workDays, [day]: 0.5 });
                setLeaveDays({ ...leaveDays, [day]: 0.5 });
            } else {
                setLeaveDays({ ...leaveDays, [day]: 1 });
            }
        }
    };
    

    const handleSubmit = async () => {
        try {
            setLoading(true);

            const alreadyDeclared = await checkDeclarationMonthAlreadyExists(selectedMonth, selectedYear, selectedUserId);
            if (alreadyDeclared) {
                setLoading(false);
                return;
            }
            const token = localStorage.getItem('token');
            const formattedWorkDays = Object.keys(workDays)
                .filter(day => workDays[day])
                .map(day => new Date(selectedYear, selectedMonth - 1, day).toLocaleDateString('fr-CA'));
            const formattedLeaveDays = Object.keys(leaveDays)
                .filter(day => leaveDays[day])
                .map(day => new Date(selectedYear, selectedMonth - 1, day).toLocaleDateString('fr-CA'));
    
            const payload = {
                workDays: formattedWorkDays,
                leaveDays: formattedLeaveDays,
                Id_Utilisateur: selectedUserId
            };
    
            const response = await axios.post(`${apiUrl}/declarations`, payload, {
                headers: { Authorization: `Bearer ${token}` }
            });
    
            if (response.status >= 200 && response.status < 300) {
                setNotification({
                    open: true,
                    message: response.data?.message || 'Déclaration enregistrée avec succès.',
                    severity: 'success'
                });

                setTimeout(() => {
                    navigate('/Déclarations', {
                        state: { selectedUserId: normalizeUserId(selectedUserId) }
                    });
                }, 1200);
            }
        } catch (error) {
            console.error("Erreur lors de l'ajout :", error);
            setNotification({ open: true, message: "Erreur lors de l'ajout.", severity: 'error' });
        } finally {
            setLoading(false);
        }
    };     

    const handleUpdate = async () => {
        try {
            setLoading(true);
            const token = localStorage.getItem('token');
            const formattedWorkDays = Object.keys(workDays)
                .filter(day => workDays[day])
                .map(day => new Date(selectedYear, selectedMonth - 1, day).toLocaleDateString('fr-CA'));
            const formattedLeaveDays = Object.keys(leaveDays)
                .filter(day => leaveDays[day])
                .map(day => new Date(selectedYear, selectedMonth - 1, day).toLocaleDateString('fr-CA'));
    
            const payload = {
    workDays: formattedWorkDays,
    leaveDays: formattedLeaveDays,
    Id_Utilisateur: selectedUserId,
    Id_Declaration: declarationId
};
    
            const response = await axios.put(`${apiUrl}/declarations/${declarationId}`, payload, {
                headers: { Authorization: `Bearer ${token}` }
            });
    
            if (response.status === 200) {
                setNotification({ open: true, message: 'Déclaration modifiée avec succès.', severity: 'success' });
                setTimeout(() =>navigate('/Déclarations', { state: { selectedUserId } }), 1500);
            }
        } catch (error) {
            console.error("Erreur lors de la mise à jour :", error);
            setNotification({ open: true, message: "Erreur lors de la mise à jour.", severity: 'error' });
        } finally {
            setLoading(false);
        }
    };
    

    const handleMouseDown = (day, type) => {
        setIsDragging(true);
        setCurrentType(type);
        toggleDay(day, type);
    };

    const handleMouseOver = (day) => {
        if (isDragging && currentType) {
            toggleDay(day, currentType);
        }
    };

    const handleMouseUp = () => {
        setIsDragging(false);
        setCurrentType(null);
    };

    const getFrenchHolidays = (year) => {
        const holidays = new Set([
            `${year}-01-01`, // Nouvel An
            `${year}-05-01`, // Fête du Travail
            `${year}-05-08`, // Victoire 1945
            `${year}-07-14`, // Fête Nationale
            `${year}-08-15`, // Assomption
            `${year}-11-01`, // Toussaint
            `${year}-11-11`, // Armistice
            `${year}-12-25`  // Noël
        ]);
    
        // Calcul de Pâques
        const a = year % 19;
        const b = Math.floor(year / 100);
        const c = year % 100;
        const d = Math.floor(b / 4);
        const e = b % 4;
        const f = Math.floor((b + 8) / 25);
        const g = Math.floor((b - f + 1) / 3);
        const h = (19 * a + b - d - g + 15) % 30;
        const i = Math.floor(c / 4);
        const k = c % 4;
        const l = (32 + 2 * e + 2 * i - h - k) % 7;
        const m = Math.floor((a + 11 * h + 22 * l) / 451);
        const month = Math.floor((h + l - 7 * m + 114) / 31);
        const day = ((h + l - 7 * m + 114) % 31) + 1;
    
        const easter = new Date(year, month - 1, day);
        const easterMonday = new Date(easter);
        easterMonday.setDate(easter.getDate() + 1);
        const ascensionDay = new Date(easter);
        ascensionDay.setDate(easter.getDate() + 39);
        const pentecostMonday = new Date(easter);
        pentecostMonday.setDate(easter.getDate() + 50);
    
        holidays.add(easter.toLocaleDateString('fr-CA'));
        holidays.add(easterMonday.toLocaleDateString('fr-CA'));
        holidays.add(ascensionDay.toLocaleDateString('fr-CA'));
        holidays.add(pentecostMonday.toLocaleDateString('fr-CA'));
    
        return holidays;
    };
    
    
    const holidays = getFrenchHolidays(selectedYear);
    
    const isHoliday = (day, month, year, holidays) => {
        if (!month || !year) return false;
        const date = new Date(year, month - 1, day);  // Mois indexé de 0 à 11
        const formattedDate = date.toLocaleDateString('fr-CA');  // Format en 'YYYY-MM-DD'
        return holidays.has(formattedDate);
    };
    
    const isWeekend = (day, month, year) => {
        const date = new Date(year, month - 1, day);
        const dayOfWeek = date.getDay();
        return dayOfWeek === 0 || dayOfWeek === 6; // Dimanche = 0, Samedi = 6
    };

    
    const daysInMonth = selectedMonth ? getDaysInMonth(selectedYear, selectedMonth) : [];

    const isToday = (day, month, year) => {
        const today = new Date();
        return (
          day === today.getDate() &&
          month === today.getMonth() + 1 &&
          year === today.getFullYear()
        );
      };

    
  

    return (
      <LayoutDashboard>
    <div className="declarations-add-page" onMouseUp={handleMouseUp}>
        <Container maxWidth="lg" sx={{ p: 0 }}>
                <div className="header">
                    <Typography variant="h1" gutterBottom align="center" sx={{ color: '#FFFF', marginBottom: '10px' }}>
                        {isEditMode ? "Modifier une déclaration" : "Ajouter une déclaration"}
                    </Typography>
                </div>
                
                <div className="month-selector">
                    <Typography variant="h6" sx={{ color: '#0B349D' }}>Sélectionner le Mois et l'Année :</Typography>
                    <div className="select-row">
                        <Select
                            value={selectedMonth || ''}
                            onChange={handleMonthChange}
                            disabled={isEditMode}   // ✅ ajoute cette ligne
                            displayEmpty
                            variant="outlined"
                            fullWidth
                            sx={{ bgcolor: 'white', borderRadius: '4px' }}
                        >
                            <MenuItem value="" disabled>Choisir un mois</MenuItem>
                            {Array.from({ length: 12 }, (_, index) => (
                                <MenuItem key={index + 1} value={index + 1}>
                                    {new Date(0, index).toLocaleString('default', { month: 'long' })}
                                </MenuItem>
                            ))}
                        </Select>

                        <Select
                            value={selectedYear}
                            onChange={handleYearChange}
                            disabled={isEditMode}   // ✅ ajoute cette ligne
                            displayEmpty
                            variant="outlined"
                            fullWidth
                            sx={{ bgcolor: 'white', borderRadius: '4px' }}
                        >
                            {Array.from({ length: 5 }, (_, index) => {
                                const year = 2025 + index;
                                return (
                                    <MenuItem key={year} value={year}>
                                        {year}
                                    </MenuItem>
                                );
                            })}
                        </Select>
                    </div>
                </div>

                {selectedMonth && isDaysLoading && (
  <div style={{ display:'flex', alignItems:'center', justifyContent:'center', gap:12, minHeight:120 }}>
    <NovaSectionLoader label="Chargement des données" helper="Merci de patienter quelques secondes." />
    <Typography>Chargement des jours déjà déclarés…</Typography>
  </div>
)}

                {selectedMonth && !isDaysLoading && (
    <div 
        className="table-wrapper" 
        style={{ 
            overflowX: 'auto', 
            whiteSpace: 'nowrap', 
            display: 'block', 
            maxWidth: '100%' // Assure que le défilement fonctionne bien
        }}
    >
        <table className="styled-table" style={{ tableLayout: 'fixed', width: '150%' }}>
            <thead>
                <tr>
                    <th className="main-column">Jours du Mois</th>
                    {daysInMonth.map(day => {
  const isCurrent = isToday(day, selectedMonth, selectedYear);
  const isWeekendDay = isWeekend(day, selectedMonth, selectedYear);
  const isHolidayDay = isHoliday(day, selectedMonth, selectedYear, holidays);

  return (
    <th
      key={day}
      className={`day-column ${isWeekendDay ? 'nova-weekend-day-cell' : ''} ${isHolidayDay ? 'nova-holiday-day-cell' : ''}`.trim()}
      style={{
        minWidth: '80px',
        backgroundColor: isCurrent
          ? '#fff2b3'
          : isHolidayDay
          ? '#94a3b8'
          : isWeekendDay
          ? '#cbd5e1'
          : '',
        color: isCurrent ? 'black' : (isWeekendDay || isHolidayDay) ? '#0f172a' : '',
        fontWeight: isCurrent ? 'bold' : 'normal',
        border: isHolidayDay ? '2px dashed #64748b' : isWeekendDay ? '2px dashed #94a3b8' : undefined,
        cursor: isWeekendDay || isHolidayDay ? 'not-allowed' : 'default'
      }}
    >
      {day}
    </th>
  );
})}
                </tr>
            </thead>
            <tbody>
  {/* --- LIGNE TRAVAIL --- */}
  <tr>
    <td className="main-column">Jours de Travail</td>
    {daysInMonth.map(day => {
      const isWeekendDay = isWeekend(day, selectedMonth, selectedYear);
                                            const isHolidayDay = isHoliday(day, selectedMonth, selectedYear, holidays);
                                            const isGray = isWeekendDay || isHolidayDay;
      const isBlocked = blockedDaysMap[day] === "bloqué";
      const isSelected = workDays[day] === 1;
      const isHalfDay = workDays[day] === 0.5 && leaveDays[day] === 0.5;

      return (
        <td
                                                className={`${isWeekendDay ? 'nova-weekend-day-cell' : ''} ${isHolidayDay ? 'nova-holiday-day-cell' : ''} ${isBlocked ? 'nova-existing-day-cell' : ''}`.trim()}
          key={`work-${day}`}
          onMouseDown={() => { if (!(isGray || isBlocked)) handleMouseDown(day, "work"); }}
          onMouseOver={() => { if (isDragging && currentType && !(isGray || isBlocked)) handleMouseOver(day); }}
          onMouseUp={handleMouseUp}
          title={isBlocked ? "Jour déjà déclaré (bloqué)" : ""}
          style={{
            backgroundColor: isBlocked
              ? '#93c5fd'
              : isHolidayDay
              ? '#94a3b8'
              : isWeekendDay
              ? '#cbd5e1'
              : isHalfDay
              ? '#9ecfff'
              : isSelected
              ? '#007bff'
              : '',
            cursor: (isGray || isBlocked) ? 'not-allowed' : 'pointer',
            minWidth: '80px',
            color: (isGray || isBlocked) ? '#0f172a' : undefined,
            opacity: 1,
            border: isBlocked
              ? '2px dashed #3b82f6'
              : isHolidayDay
              ? '2px dashed #64748b'
              : isWeekendDay
              ? '2px dashed #94a3b8'
              : undefined
          }}
        >
          {workDays[day] === 1 ? '1' : workDays[day] === 0.5 ? '0.5' : ''}
        </td>
      );
    })}
  </tr>

  {/* --- LIGNE CONGÉ --- */}
  <tr>
    <td className="main-column">Jours de Congé</td>
    {daysInMonth.map(day => {
      const isWeekendDay = isWeekend(day, selectedMonth, selectedYear);
                                            const isHolidayDay = isHoliday(day, selectedMonth, selectedYear, holidays);
                                            const isGray = isWeekendDay || isHolidayDay;
      const isBlocked = blockedDaysMap[day] === "bloqué";
      const isSelected = leaveDays[day] === 1;
      const isHalfDay = workDays[day] === 0.5 && leaveDays[day] === 0.5;

      return (
        <td
                                                className={`${isWeekendDay ? 'nova-weekend-day-cell' : ''} ${isHolidayDay ? 'nova-holiday-day-cell' : ''} ${isBlocked ? 'nova-existing-day-cell' : ''}`.trim()}
          key={`leave-${day}`}
          onMouseDown={() => { if (!(isGray || isBlocked)) handleMouseDown(day, "leave"); }}
          onMouseOver={() => { if (isDragging && currentType && !(isGray || isBlocked)) handleMouseOver(day); }}
          onMouseUp={handleMouseUp}
          title={isBlocked ? "Jour déjà déclaré (bloqué)" : ""}
          style={{
            backgroundColor: isBlocked
              ? '#93c5fd'
              : isHolidayDay
              ? '#94a3b8'
              : isWeekendDay
              ? '#cbd5e1'
              : isHalfDay
              ? '#a5f7a5'
              : isSelected
              ? '#28a745'
              : '',
            cursor: (isGray || isBlocked) ? 'not-allowed' : 'pointer',
            minWidth: '80px',
            color: (isGray || isBlocked) ? '#0f172a' : undefined,
            opacity: 1,
            border: isBlocked
              ? '2px dashed #3b82f6'
              : isHolidayDay
              ? '2px dashed #64748b'
              : isWeekendDay
              ? '2px dashed #94a3b8'
              : undefined
          }}
        >
          {leaveDays[day] === 1 ? '1' : leaveDays[day] === 0.5 ? '0.5' : ''}
        </td>
      );
    })}
  </tr>
</tbody>

        </table>
    </div>
)}

<div className="actions-row">

<Button 
className="primary-btn"
onClick={isEditMode ? handleUpdate : handleSubmit}
    disabled={!isEditMode && monthDeclarationBlocked}
>
{isEditMode ? "Valider les modifications" : "Ajouter la déclaration"}
</Button>

<Button 
className="primary-btn"
onClick={() => navigate('/Déclarations', { state: { selectedUserId } })}
>
Retourner à la liste
</Button>

</div>
{loadingEditView && (
                        <Snackbar
                            open={true}
                            anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                            autoHideDuration={null}
                        >
                            <Alert
                                severity="info"
                                sx={{
                                    width: '100%',
                                    fontSize: '1rem',
                                    fontWeight: 'bold',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                }}
                            >
                                Merci de patienter pendant le chargement...
                            </Alert>
                        </Snackbar>
                    )}

{loading && (
  <Snackbar
    open={true}
    anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
    autoHideDuration={null}
  >
    <Alert
      severity="info"
      sx={{
        width: '100%',
        fontSize: '1rem',
        fontWeight: 'bold',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      
      Merci de patienter...
    </Alert>
  </Snackbar>
)}

<Snackbar
  open={notification.open}
  autoHideDuration={3000}
  onClose={() => setNotification({ ...notification, open: false })}
  anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
>
  <Alert
    severity={notification.severity}
    sx={{
      width: '100%',
      fontSize: '1rem',
      fontWeight: 'bold',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
      borderRadius: '8px',
    }}
  >
    {notification.message}
  </Alert>
</Snackbar>

            </Container>
        </div>
        </LayoutDashboard>

    );
};

export default AjouterDeclarations;
